<template>
  <div class="sensitiveWord-topbar">
    <div class="sensitive-list-topbar">
      <div class="select">
        <!-- 搜索框 -->
        <div class="notice-search">
          <search :placeholder="placeholder" @search="search" />
        </div>
        <!-- 创建者 -->
        <!-- <div class="sensitiveWord-select-establish">
          <span>创建者</span>
          <div class="establish-select">
            <el-select
              v-model="selectCreatorText"
              placeholder="创建者"
              @change="selectCreatorType"
            >
              <el-option
                :label="item"
                :value="item"
                v-for="(item, index) in creatorOptions"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <el-tooltip
            class="item"
            effect="dark"
            content="只有本人创建的可以删改"
            placement="bottom-start"
          >
            <i class="el-icon-question"></i>
          </el-tooltip>
        </div> -->
        <!-- 分类 -->
        <div class="sensitiveWord-select-classify">
          <span>分类</span>
          <div class="sensitiveWord-select">
            <el-select v-model="selectText" placeholder="分类" @change="selectType">
              <el-option
                :label="item"
                :value="item"
                v-for="(item, index) in options"
                :key="index"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <!-- 添加删除修改 -->
      <div class="notice-operation-part-container">
        <button class="button cancel" @click="cancel" v-show="cancelBtnShow">取消</button>
        <button
          class="button add"
          @click="add"
          v-show="!cancelBtnShow"
          v-hasPermi="'sc:sensitiveword:add'"
        >
          添加
        </button>
        <button
          class="button delete"
          @click="del"
          v-show="!cancelBtnShow"
          v-hasPermi="'sc:sensitiveword:delete'"
        >
          单个删除
        </button>
        <button
          class="button delete"
          @click="delBatch"
          v-show="!cancelBtnShow"
          v-hasPermi="'sc:sensitiveword:delete'"
        >
          批量删除
        </button>
        <button class="button delete" v-show="batchBtnShow" @click="handleCheckAllChange">
          {{ checkAllText }}
        </button>
        <button class="button delete" v-show="batchBtnShow" @click="delbatchClick">
          删除
        </button>
        <button
          class="button revise"
          @click="revise"
          v-show="!cancelBtnShow"
          v-hasPermi="'sc:sensitiveword:edit'"
        >
          修改
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import search from "@/components/search/search.vue";
export default {
  data() {
    return {
      selectText: "全部",
      closableType: false,
      selectCreatorText: "全部",
      creatorOptions: ["全部", "本人"],
      cancelBtnShow: false,
      batchBtnShow: false,
      checkAll: false,
      checkAllText: "全选",
      placeholder: "请输入敏感词",
    };
  },
  components: {
    search,
  },
  props: {
    options: {
      type: Array,
    },
    // 批量删除按钮组显示
    batchBtnShowType: {
      type: [Number, Boolean],
    },
    // 取消按钮显示
    cancelBtnShowType: {
      type: [Number, Boolean],
    },
  },
  watch: {
    // 监听批量删除和取消按钮显示(分页被点击时切换显示状态)
    batchBtnShowType: {
      handler(val) {
        this.batchBtnShow = false;
      },
      immeidate: true,
    },
    cancelBtnShowType: {
      handler(val) {
        this.cancelBtnShow = false;
      },
      immeidate: true,
    },
  },
  methods: {
    // 搜索
    search(e) {
      // console.log(e);
      this.$emit("search", e);
    },
    // 批量删除
    delbatchClick() {
      this.$emit("delbatch", true);
    },
    // 全选
    handleCheckAllChange() {
      this.checkAll = !this.checkAll;
      this.checkAllText = this.checkAll ? "取消全选" : "全选";
      this.$emit("checkAllType", this.checkAll);
    },
    delBatch() {
      this.batchBtnShow = true;
      this.cancelBtnShow = true;
      this.$emit("editShow", "deleteBatch");
    },
    del() {
      this.cancelBtnShow = true;
      this.$emit("editShow", "delete");
    },
    add() {
      this.$emit("addShow", true);
    },
    revise() {
      this.cancelBtnShow = true;
      this.$emit("editShow", "update");
    },
    cancel() {
      this.batchBtnShow = false;
      this.cancelBtnShow = false;
      this.$emit("editShow", "123");
      this.checkAll = false;
      this.checkAllText = "全选";
      this.$emit("checkAllType", this.checkAll);
    },
    // 分类
    selectType(e) {
      this.$emit("selectType", e);
      // 切换状态时重新请求数据
      this.$emit("getPageNum", 1);
      this.cancelBtnShow = false;
      this.batchBtnShow = false;
    },
    // 创建者
    selectCreatorType(e) {
      this.$emit("creator", e);
      // 切换状态时重新请求数据
      this.$emit("getPageNum", 1);
      this.cancelBtnShow = false;
      this.batchBtnShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./sensitiveWord-topbar.scss";
</style>
